interface FooterProps {
  brand: string;
  email: string;
}

export function Footer({ brand, email }: FooterProps) {
  const year = new Date().getFullYear();

  const columns = [
    { heading: "Practice", links: ["Applied AI", "Full-stack", "Network & IT"] },
    { heading: "Connect", links: [email, "LinkedIn", "GitHub"] },
    { heading: "Other", links: ["Vancouver, BC · Canada", "Open to hire", `© ${year}`] },
  ];

  return (
    <footer
      style={{
        position: "relative",
        padding: "64px 32px 40px",
        borderTop: "1px solid var(--hairline)",
        background: "color-mix(in oklab, var(--paper-soft) 82%, transparent)",
        backdropFilter: "blur(6px)",
      }}
    >
      <div className="container" style={{ display: "flex", flexDirection: "column", gap: 48 }}>
        <div
          style={{
            fontFamily: "var(--font-display)",
            fontWeight: 300,
            fontSize: "clamp(80px, 18vw, 220px)",
            lineHeight: 0.86,
            letterSpacing: "-0.04em",
            color: "var(--ink)",
            opacity: 0.96,
            display: "flex",
            alignItems: "baseline",
            gap: 16,
          }}
        >
          <span>{brand.toLowerCase()}</span>
          <span style={{ color: "var(--beam)", fontSize: "0.5em" }}>·</span>
        </div>

        <div
          className="grid-3"
          style={{
            display: "grid",
            gridTemplateColumns: "1.4fr 1fr 1fr 1fr",
            gap: 32,
            paddingTop: 32,
            borderTop: "1px solid var(--hairline)",
          }}
        >
          <div style={{ display: "flex", flexDirection: "column", gap: 12, maxWidth: 320 }}>
            <span
              style={{
                fontFamily: "var(--font-display)",
                fontWeight: 500,
                fontSize: 14,
                letterSpacing: "0.04em",
                textTransform: "uppercase",
                color: "var(--ink)",
              }}
            >
              {brand}
            </span>
            <span style={{ fontFamily: "var(--font-body)", fontSize: 13, lineHeight: 1.6, color: "var(--ink-3)" }}>
              Senior software engineering for applied AI, full-stack product, and modern IT. A solo practice operating out of Vancouver, BC.
            </span>
          </div>

          {columns.map((column) => (
            <div key={column.heading} style={{ display: "flex", flexDirection: "column", gap: 12 }}>
              <span
                style={{
                  fontFamily: "var(--font-display)",
                  fontWeight: 500,
                  fontSize: 11,
                  letterSpacing: "0.18em",
                  textTransform: "uppercase",
                  color: "var(--ink-4)",
                }}
              >
                {column.heading}
              </span>
              <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                {column.links.map((link) => (
                  <a
                    key={link}
                    href="#top"
                    className="chrome"
                    style={{ fontFamily: "var(--font-body)", fontSize: 13, color: "var(--ink-2)", textDecoration: "none", borderBottom: 0 }}
                  >
                    {link}
                  </a>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div
          style={{
            paddingTop: 24,
            borderTop: "1px solid var(--hairline)",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: 16,
          }}
        >
          <span style={{ fontFamily: "var(--font-mono)", fontSize: 11, letterSpacing: "0.04em", color: "var(--ink-4)" }}>
            Built quietly · {year}
          </span>
          <span style={{ fontFamily: "var(--font-mono)", fontSize: 11, letterSpacing: "0.04em", color: "var(--ink-5)" }}>
            49°16′N · 123°07′W
          </span>
        </div>
      </div>
    </footer>
  );
}
